import React from 'react';
import { Route } from 'react-router-dom';

import DocumentTitle from '../generic/DocumentTitle';
import AddUser from './AddUser';
import ListUsers from './ListUsers';
import ShowUser from './ShowUser';

function Routes() {
  return (
    <DocumentTitle title="Users">
      <Route path="/users" exact component={ListUsers} />
      <Route path="/users/add" component={AddUser} />
      <Route path="/users/:id/show" component={ShowUser} />
    </DocumentTitle>
  );
}

export default Routes;
